export const countryCodes = [
    // Öncelikli Ülkeler
	{ nameKey: 'country_tr', dial_code: '+90', code: 'TR', flag: '🇹🇷' },
	{ nameKey: 'country_us', dial_code: '+1', code: 'US', flag: '🇺🇸' },
	{ nameKey: 'country_gb', dial_code: '+44', code: 'GB', flag: '🇬🇧' },
	{ nameKey: 'country_de', dial_code: '+49', code: 'DE', flag: '🇩🇪' },
	{ nameKey: 'country_fr', dial_code: '+33', code: 'FR', flag: '🇫🇷' },
    { nameKey: 'country_es', dial_code: '+34', code: 'ES', flag: '🇪🇸' },
    { nameKey: 'country_it', dial_code: '+39', code: 'IT', flag: '🇮🇹' },
    { nameKey: 'country_ca', dial_code: '+1', code: 'CA', flag: '🇨🇦' }, // ABD ile aynı kodu paylaşır
    { nameKey: 'country_ru', dial_code: '+7', code: 'RU', flag: '🇷🇺' },

    // Alfabetik Sıralı Diğer Ülkeler
    { nameKey: 'country_af', dial_code: '+93', code: 'AF', flag: '🇦🇫' },
    { nameKey: 'country_ax', dial_code: '+358', code: 'AX', flag: '🇦🇽' },
    { nameKey: 'country_al', dial_code: '+355', code: 'AL', flag: '🇦🇱' },
    { nameKey: 'country_dz', dial_code: '+213', code: 'DZ', flag: '🇩🇿' },
    { nameKey: 'country_as', dial_code: '+1684', code: 'AS', flag: '🇦🇸' },
    { nameKey: 'country_ad', dial_code: '+376', code: 'AD', flag: '🇦🇩' },
    { nameKey: 'country_ao', dial_code: '+244', code: 'AO', flag: '🇦🇴' },
    { nameKey: 'country_ai', dial_code: '+1264', code: 'AI', flag: '🇦🇮' },
    { nameKey: 'country_ag', dial_code: '+1268', code: 'AG', flag: '🇦🇬' },
    { nameKey: 'country_ar', dial_code: '+54', code: 'AR', flag: '🇦🇷' },
    { nameKey: 'country_am', dial_code: '+374', code: 'AM', flag: '🇦🇲' },
    { nameKey: 'country_aw', dial_code: '+297', code: 'AW', flag: '🇦🇼' },
    { nameKey: 'country_au', dial_code: '+61', code: 'AU', flag: '🇦🇺' },
    { nameKey: 'country_at', dial_code: '+43', code: 'AT', flag: '🇦🇹' },
    { nameKey: 'country_az', dial_code: '+994', code: 'AZ', flag: '🇦🇿' },
    { nameKey: 'country_bs', dial_code: '+1242', code: 'BS', flag: '🇧🇸' },
    { nameKey: 'country_bh', dial_code: '+973', code: 'BH', flag: '🇧🇭' },
    { nameKey: 'country_bd', dial_code: '+880', code: 'BD', flag: '🇧🇩' },
    { nameKey: 'country_bb', dial_code: '+1246', code: 'BB', flag: '🇧🇧' },
    { nameKey: 'country_by', dial_code: '+375', code: 'BY', flag: '🇧🇾' },
    { nameKey: 'country_be', dial_code: '+32', code: 'BE', flag: '🇧🇪' },
    { nameKey: 'country_bz', dial_code: '+501', code: 'BZ', flag: '🇧🇿' },
    { nameKey: 'country_bj', dial_code: '+229', code: 'BJ', flag: '🇧🇯' },
    { nameKey: 'country_bm', dial_code: '+1441', code: 'BM', flag: '🇧🇲' },
    { nameKey: 'country_bt', dial_code: '+975', code: 'BT', flag: '🇧🇹' },
    { nameKey: 'country_bo', dial_code: '+591', code: 'BO', flag: '🇧🇴' },
    { nameKey: 'country_ba', dial_code: '+387', code: 'BA', flag: '🇧🇦' },
    { nameKey: 'country_bw', dial_code: '+267', code: 'BW', flag: '🇧🇼' },
    { nameKey: 'country_br', dial_code: '+55', code: 'BR', flag: '🇧🇷' },
    { nameKey: 'country_io', dial_code: '+246', code: 'IO', flag: '🇮🇴' },
    { nameKey: 'country_vg', dial_code: '+1284', code: 'VG', flag: '🇻🇬' },
    { nameKey: 'country_bn', dial_code: '+673', code: 'BN', flag: '🇧🇳' },
    { nameKey: 'country_bg', dial_code: '+359', code: 'BG', flag: '🇧🇬' },
    { nameKey: 'country_bf', dial_code: '+226', code: 'BF', flag: '🇧🇫' },
    { nameKey: 'country_bi', dial_code: '+257', code: 'BI', flag: '🇧🇮' },
    { nameKey: 'country_kh', dial_code: '+855', code: 'KH', flag: '🇰🇭' },
    { nameKey: 'country_cm', dial_code: '+237', code: 'CM', flag: '🇨🇲' },
    { nameKey: 'country_cv', dial_code: '+238', code: 'CV', flag: '🇨🇻' },
    { nameKey: 'country_ky', dial_code: '+345', code: 'KY', flag: '🇰🇾' },
    { nameKey: 'country_cf', dial_code: '+236', code: 'CF', flag: '🇨🇫' },
    { nameKey: 'country_td', dial_code: '+235', code: 'TD', flag: '🇹🇩' },
    { nameKey: 'country_cl', dial_code: '+56', code: 'CL', flag: '🇨🇱' },
    { nameKey: 'country_cn', dial_code: '+86', code: 'CN', flag: '🇨🇳' },
    { nameKey: 'country_cx', dial_code: '+61', code: 'CX', flag: '🇨🇽' },
    { nameKey: 'country_cc', dial_code: '+61', code: 'CC', flag: '🇨🇨' },
    { nameKey: 'country_co', dial_code: '+57', code: 'CO', flag: '🇨🇴' },
    { nameKey: 'country_km', dial_code: '+269', code: 'KM', flag: '🇰🇲' },
    { nameKey: 'country_cg', dial_code: '+242', code: 'CG', flag: '🇨🇬' },
    { nameKey: 'country_cd', dial_code: '+243', code: 'CD', flag: '🇨🇩' },
    { nameKey: 'country_ck', dial_code: '+682', code: 'CK', flag: '🇨🇰' },
    { nameKey: 'country_cr', dial_code: '+506', code: 'CR', flag: '🇨🇷' },
    { nameKey: 'country_hr', dial_code: '+385', code: 'HR', flag: '🇭🇷' },
    { nameKey: 'country_cu', dial_code: '+53', code: 'CU', flag: '🇨🇺' },
    { nameKey: 'country_cy', dial_code: '+357', code: 'CY', flag: '🇨🇾' },
    { nameKey: 'country_cz', dial_code: '+420', code: 'CZ', flag: '🇨🇿' },
    { nameKey: 'country_dk', dial_code: '+45', code: 'DK', flag: '🇩🇰' },
    { nameKey: 'country_dj', dial_code: '+253', code: 'DJ', flag: '🇩🇯' },
    { nameKey: 'country_dm', dial_code: '+1767', code: 'DM', flag: '🇩🇲' },
    { nameKey: 'country_do', dial_code: '+1849', code: 'DO', flag: '🇩🇴' },
    { nameKey: 'country_ec', dial_code: '+593', code: 'EC', flag: '🇪🇨' },
    { nameKey: 'country_eg', dial_code: '+20', code: 'EG', flag: '🇪🇬' },
    { nameKey: 'country_sv', dial_code: '+503', code: 'SV', flag: '🇸🇻' },
    { nameKey: 'country_gq', dial_code: '+240', code: 'GQ', flag: '🇬🇶' },
    { nameKey: 'country_er', dial_code: '+291', code: 'ER', flag: '🇪🇷' },
    { nameKey: 'country_ee', dial_code: '+372', code: 'EE', flag: '🇪🇪' },
    { nameKey: 'country_sz', dial_code: '+268', code: 'SZ', flag: '🇸🇿' },
    { nameKey: 'country_et', dial_code: '+251', code: 'ET', flag: '🇪🇹' },
    { nameKey: 'country_fk', dial_code: '+500', code: 'FK', flag: '🇫🇰' },
    { nameKey: 'country_fo', dial_code: '+298', code: 'FO', flag: '🇫🇴' },
    { nameKey: 'country_fj', dial_code: '+679', code: 'FJ', flag: '🇫🇯' },
    { nameKey: 'country_fi', dial_code: '+358', code: 'FI', flag: '🇫🇮' },
    { nameKey: 'country_gf', dial_code: '+594', code: 'GF', flag: '🇬🇫' },
    { nameKey: 'country_pf', dial_code: '+689', code: 'PF', flag: '🇵🇫' },
    { nameKey: 'country_ga', dial_code: '+241', code: 'GA', flag: '🇬🇦' },
    { nameKey: 'country_gm', dial_code: '+220', code: 'GM', flag: '🇬🇲' },
    { nameKey: 'country_ge', dial_code: '+995', code: 'GE', flag: '🇬🇪' },
    { nameKey: 'country_gh', dial_code: '+233', code: 'GH', flag: '🇬🇭' },
    { nameKey: 'country_gi', dial_code: '+350', code: 'GI', flag: '🇬🇮' },
    { nameKey: 'country_gr', dial_code: '+30', code: 'GR', flag: '🇬🇷' },
    { nameKey: 'country_gl', dial_code: '+299', code: 'GL', flag: '🇬🇱' },
    { nameKey: 'country_gd', dial_code: '+1473', code: 'GD', flag: '🇬🇩' },
    { nameKey: 'country_gp', dial_code: '+590', code: 'GP', flag: '🇬🇵' },
    { nameKey: 'country_gu', dial_code: '+1671', code: 'GU', flag: '🇬🇺' },
    { nameKey: 'country_gt', dial_code: '+502', code: 'GT', flag: '🇬🇹' },
    { nameKey: 'country_gg', dial_code: '+44', code: 'GG', flag: '🇬🇬' },
    { nameKey: 'country_gn', dial_code: '+224', code: 'GN', flag: '🇬🇳' },
    { nameKey: 'country_gw', dial_code: '+245', code: 'GW', flag: '🇬🇼' },
    { nameKey: 'country_gy', dial_code: '+595', code: 'GY', flag: '🇬🇾' },
    { nameKey: 'country_ht', dial_code: '+509', code: 'HT', flag: '🇭🇹' },
    { nameKey: 'country_hn', dial_code: '+504', code: 'HN', flag: '🇭🇳' },
    { nameKey: 'country_hk', dial_code: '+852', code: 'HK', flag: '🇭🇰' },
    { nameKey: 'country_hu', dial_code: '+36', code: 'HU', flag: '🇭🇺' },
    { nameKey: 'country_is', dial_code: '+354', code: 'IS', flag: '🇮🇸' },
    { nameKey: 'country_in', dial_code: '+91', code: 'IN', flag: '🇮🇳' },
    { nameKey: 'country_id', dial_code: '+62', code: 'ID', flag: '🇮🇩' },
    { nameKey: 'country_ir', dial_code: '+98', code: 'IR', flag: '🇮🇷' },
    { nameKey: 'country_iq', dial_code: '+964', code: 'IQ', flag: '🇮🇶' },
    { nameKey: 'country_im', dial_code: '+44', code: 'IM', flag: '🇮🇲' },
    { nameKey: 'country_il', dial_code: '+972', code: 'IL', flag: '🇮🇱' },
    { nameKey: 'country_ci', dial_code: '+225', code: 'CI', flag: '🇨🇮' },
    { nameKey: 'country_jm', dial_code: '+1876', code: 'JM', flag: '🇯🇲' },
    { nameKey: 'country_jp', dial_code: '+81', code: 'JP', flag: '🇯🇵' },
    { nameKey: 'country_je', dial_code: '+44', code: 'JE', flag: '🇯🇪' },
    { nameKey: 'country_jo', dial_code: '+962', code: 'JO', flag: '🇯🇴' },
    { nameKey: 'country_kz', dial_code: '+77', code: 'KZ', flag: '🇰🇿' },
    { nameKey: 'country_ke', dial_code: '+254', code: 'KE', flag: '🇰🇪' },
    { nameKey: 'country_ki', dial_code: '+686', code: 'KI', flag: '🇰🇮' },
    { nameKey: 'country_kw', dial_code: '+965', code: 'KW', flag: '🇰🇼' },
    { nameKey: 'country_kg', dial_code: '+996', code: 'KG', flag: '🇰🇬' },
    { nameKey: 'country_la', dial_code: '+856', code: 'LA', flag: '🇱🇦' },
    { nameKey: 'country_lv', dial_code: '+371', code: 'LV', flag: '🇱🇻' },
    { nameKey: 'country_lb', dial_code: '+961', code: 'LB', flag: '🇱🇧' },
    { nameKey: 'country_ls', dial_code: '+266', code: 'LS', flag: '🇱🇸' },
    { nameKey: 'country_lr', dial_code: '+231', code: 'LR', flag: '🇱🇷' },
    { nameKey: 'country_ly', dial_code: '+218', code: 'LY', flag: '🇱🇾' },
    { nameKey: 'country_li', dial_code: '+423', code: 'LI', flag: '🇱🇮' },
    { nameKey: 'country_lt', dial_code: '+370', code: 'LT', flag: '🇱🇹' },
    { nameKey: 'country_mo', dial_code: '+853', code: 'MO', flag: '🇲🇴' },
    { nameKey: 'country_mk', dial_code: '+389', code: 'MK', flag: '🇲🇰' },
    { nameKey: 'country_mg', dial_code: '+261', code: 'MG', flag: '🇲🇬' },
    { nameKey: 'country_mw', dial_code: '+265', code: 'MW', flag: '🇲🇼' },
    { nameKey: 'country_my', dial_code: '+60', code: 'MY', flag: '🇲🇾' },
    { nameKey: 'country_mv', dial_code: '+960', code: 'MV', flag: '🇲🇻' },
    { nameKey: 'country_ml', dial_code: '+223', code: 'ML', flag: '🇲🇱' },
    { nameKey: 'country_mh', dial_code: '+692', code: 'MH', flag: '🇲🇭' },
    { nameKey: 'country_mq', dial_code: '+596', code: 'MQ', flag: '🇲🇶' },
    { nameKey: 'country_mr', dial_code: '+222', code: 'MR', flag: '🇲🇷' },
    { nameKey: 'country_mu', dial_code: '+230', code: 'MU', flag: '🇲🇺' },
    { nameKey: 'country_yt', dial_code: '+262', code: 'YT', flag: '🇾🇹' },
    { nameKey: 'country_mx', dial_code: '+52', code: 'MX', flag: '🇲🇽' },
    { nameKey: 'country_fm', dial_code: '+691', code: 'FM', flag: '🇫🇲' },
    { nameKey: 'country_md', dial_code: '+373', code: 'MD', flag: '🇲🇩' },
    { nameKey: 'country_mc', dial_code: '+377', code: 'MC', flag: '🇲🇨' },
    { nameKey: 'country_mn', dial_code: '+976', code: 'MN', flag: '🇲🇳' },
    { nameKey: 'country_me', dial_code: '+382', code: 'ME', flag: '🇲🇪' },
    { nameKey: 'country_ms', dial_code: '+1664', code: 'MS', flag: '🇲🇸' },
    { nameKey: 'country_ma', dial_code: '+212', code: 'MA', flag: '🇲🇦' },
    { nameKey: 'country_mz', dial_code: '+258', code: 'MZ', flag: '🇲🇿' },
    { nameKey: 'country_mm', dial_code: '+95', code: 'MM', flag: '🇲🇲' },
    { nameKey: 'country_na', dial_code: '+264', code: 'NA', flag: '🇳🇦' },
    { nameKey: 'country_nr', dial_code: '+674', code: 'NR', flag: '🇳🇷' },
    { nameKey: 'country_np', dial_code: '+977', code: 'NP', flag: '🇳🇵' },
    { nameKey: 'country_nc', dial_code: '+687', code: 'NC', flag: '🇳🇨' },
    { nameKey: 'country_ni', dial_code: '+505', code: 'NI', flag: '🇳🇮' },
    { nameKey: 'country_ne', dial_code: '+227', code: 'NE', flag: '🇳🇪' },
    { nameKey: 'country_ng', dial_code: '+234', code: 'NG', flag: '🇳🇬' },
    { nameKey: 'country_nu', dial_code: '+683', code: 'NU', flag: '🇳🇺' },
    { nameKey: 'country_nf', dial_code: '+672', code: 'NF', flag: '🇳🇫' },
    { nameKey: 'country_kp', dial_code: '+850', code: 'KP', flag: '🇰🇵' },
    { nameKey: 'country_mp', dial_code: '+1670', code: 'MP', flag: '🇲🇵' },
    { nameKey: 'country_om', dial_code: '+968', code: 'OM', flag: '🇴🇲' },
    { nameKey: 'country_pk', dial_code: '+92', code: 'PK', flag: '🇵🇰' },
    { nameKey: 'country_pw', dial_code: '+680', code: 'PW', flag: '🇵🇼' },
    { nameKey: 'country_ps', dial_code: '+970', code: 'PS', flag: '🇵🇸' },
    { nameKey: 'country_pa', dial_code: '+507', code: 'PA', flag: '🇵🇦' },
    { nameKey: 'country_pg', dial_code: '+675', code: 'PG', flag: '🇵🇬' },
    { nameKey: 'country_py', dial_code: '+595', code: 'PY', flag: '🇵🇾' },
    { nameKey: 'country_pe', dial_code: '+51', code: 'PE', flag: '🇵🇪' },
    { nameKey: 'country_ph', dial_code: '+63', code: 'PH', flag: '🇵🇭' },
    { nameKey: 'country_pn', dial_code: '+872', code: 'PN', flag: '🇵🇳' },
    { nameKey: 'country_pr', dial_code: '+1939', code: 'PR', flag: '🇵🇷' },
    { nameKey: 'country_re', dial_code: '+262', code: 'RE', flag: '🇷🇪' },
    { nameKey: 'country_rw', dial_code: '+250', code: 'RW', flag: '🇷🇼' },
    { nameKey: 'country_bl', dial_code: '+590', code: 'BL', flag: '🇧🇱' },
    { nameKey: 'country_sh', dial_code: '+290', code: 'SH', flag: '🇸🇭' },
    { nameKey: 'country_kn', dial_code: '+1869', code: 'KN', flag: '🇰🇳' },
    { nameKey: 'country_lc', dial_code: '+1758', code: 'LC', flag: '🇱🇨' },
    { nameKey: 'country_mf', dial_code: '+590', code: 'MF', flag: '🇲🇫' },
    { nameKey: 'country_pm', dial_code: '+508', code: 'PM', flag: '🇵🇲' },
    { nameKey: 'country_vc', dial_code: '+1784', code: 'VC', flag: '🇻🇨' },
    { nameKey: 'country_ws', dial_code: '+685', code: 'WS', flag: '🇼🇸' },
    { nameKey: 'country_sm', dial_code: '+378', code: 'SM', flag: '🇸🇲' },
    { nameKey: 'country_st', dial_code: '+239', code: 'ST', flag: '🇸🇹' },
    { nameKey: 'country_sn', dial_code: '+221', code: 'SN', flag: '🇸🇳' },
    { nameKey: 'country_rs', dial_code: '+381', code: 'RS', flag: '🇷🇸' },
    { nameKey: 'country_sc', dial_code: '+248', code: 'SC', flag: '🇸🇨' },
    { nameKey: 'country_sl', dial_code: '+232', code: 'SL', flag: '🇸🇱' },
    { nameKey: 'country_sg', dial_code: '+65', code: 'SG', flag: '🇸🇬' },
    { nameKey: 'country_sk', dial_code: '+421', code: 'SK', flag: '🇸🇰' },
    { nameKey: 'country_si', dial_code: '+386', code: 'SI', flag: '🇸🇮' },
    { nameKey: 'country_sb', dial_code: '+677', code: 'SB', flag: '🇸🇧' },
    { nameKey: 'country_so', dial_code: '+252', code: 'SO', flag: '🇸🇴' },
    { nameKey: 'country_kr', dial_code: '+82', code: 'KR', flag: '🇰🇷' },
    { nameKey: 'country_lk', dial_code: '+94', code: 'LK', flag: '🇱🇰' },
    { nameKey: 'country_sd', dial_code: '+249', code: 'SD', flag: '🇸🇩' },
    { nameKey: 'country_sr', dial_code: '+597', code: 'SR', flag: '🇸🇷' },
    { nameKey: 'country_sy', dial_code: '+963', code: 'SY', flag: '🇸🇾' },
    { nameKey: 'country_tw', dial_code: '+886', code: 'TW', flag: '🇹🇼' },
    { nameKey: 'country_tj', dial_code: '+992', code: 'TJ', flag: '🇹🇯' },
    { nameKey: 'country_tz', dial_code: '+255', code: 'TZ', flag: '🇹🇿' },
    { nameKey: 'country_th', dial_code: '+66', code: 'TH', flag: '🇹🇭' },
    { nameKey: 'country_tl', dial_code: '+670', code: 'TL', flag: '🇹🇱' },
    { nameKey: 'country_tg', dial_code: '+228', code: 'TG', flag: '🇹🇬' },
    { nameKey: 'country_tk', dial_code: '+690', code: 'TK', flag: '🇹🇰' },
    { nameKey: 'country_to', dial_code: '+676', code: 'TO', flag: '🇹🇴' },
    { nameKey: 'country_tt', dial_code: '+1868', code: 'TT', flag: '🇹🇹' },
    { nameKey: 'country_tn', dial_code: '+216', code: 'TN', flag: '🇹🇳' },
    { nameKey: 'country_tm', dial_code: '+993', code: 'TM', flag: '🇹🇲' },
    { nameKey: 'country_tc', dial_code: '+1649', code: 'TC', flag: '🇹🇨' },
    { nameKey: 'country_tv', dial_code: '+688', code: 'TV', flag: '🇹🇻' },
    { nameKey: 'country_vi', dial_code: '+1340', code: 'VI', flag: '🇻🇮' },
    { nameKey: 'country_ug', dial_code: '+256', code: 'UG', flag: '🇺🇬' },
    { nameKey: 'country_ae', dial_code: '+971', code: 'AE', flag: '🇦🇪' },
    { nameKey: 'country_uy', dial_code: '+598', code: 'UY', flag: '🇺🇾' },
    { nameKey: 'country_uz', dial_code: '+998', code: 'UZ', flag: '🇺🇿' },
    { nameKey: 'country_vu', dial_code: '+678', code: 'VU', flag: '🇻🇺' },
    { nameKey: 'country_va', dial_code: '+379', code: 'VA', flag: '🇻🇦' },
    { nameKey: 'country_ve', dial_code: '+58', code: 'VE', flag: '🇻🇪' },
    { nameKey: 'country_vn', dial_code: '+84', code: 'VN', flag: '🇻🇳' },
    { nameKey: 'country_wf', dial_code: '+681', code: 'WF', flag: '🇼🇫' },
    { nameKey: 'country_ye', dial_code: '+967', code: 'YE', flag: '🇾🇪' },
    { nameKey: 'country_zm', dial_code: '+260', code: 'ZM', flag: '🇿🇲' },
    { nameKey: 'country_zw', dial_code: '+263', code: 'ZW', flag: '🇿🇼' }
];